__turbopack_context__.v({
  "controls": "Comparison-module__cigaCa__controls",
  "divider": "Comparison-module__cigaCa__divider",
  "event": "Comparison-module__cigaCa__event",
  "eventBody": "Comparison-module__cigaCa__eventBody",
  "eventDescription": "Comparison-module__cigaCa__eventDescription",
  "eventTitle": "Comparison-module__cigaCa__eventTitle",
  "expandButton": "Comparison-module__cigaCa__expandButton",
  "expandRow": "Comparison-module__cigaCa__expandRow",
  "hint": "Comparison-module__cigaCa__hint",
  "list": "Comparison-module__cigaCa__list",
  "modeBadge": "Comparison-module__cigaCa__modeBadge",
  "modeLegend": "Comparison-module__cigaCa__modeLegend",
  "modeOption": "Comparison-module__cigaCa__modeOption",
  "modePicker": "Comparison-module__cigaCa__modePicker",
  "older": "Comparison-module__cigaCa__older",
  "olderInner": "Comparison-module__cigaCa__olderInner",
  "root": "Comparison-module__cigaCa__root",
  "switch": "Comparison-module__cigaCa__switch",
  "time": "Comparison-module__cigaCa__time",
  "timeline": "Comparison-module__cigaCa__timeline",
});
